import { MiniButtonStyled } from './MiniButton.styles';
import { ReactNode } from 'react';
interface Props {
  text: ReactNode;
  onClick: () => void;
  editing: boolean;
  disabled?: boolean;
  'data-testid'?: string;
}

export const MiniButton = ({ text, ...props }: Props) => (
  <MiniButtonStyled {...props}>{text}</MiniButtonStyled>
);
